import { Spinner } from "@utahdts/utah-design-system";

const modalSpinnerMaskStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.05)', /* Semi-transparent black mask */
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000, /* Ensure it's on top of other elements */
  backdropFilter: 'blur(1px)', // Apply a blur effect to the background
  WebkitBackdropFilter: 'blur(1px)', // For Safari support
};

const modalSpinnerContainerStyle = {
  backgroundColor: 'white',
  padding: 20,
  borderRadius: 8,
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

const PageSpinner = () => {
    return (
        <div style={modalSpinnerMaskStyle}>
            <div style={modalSpinnerContainerStyle}>
            <Spinner size={200} strokeWidth={5}>{"Loading..."}</Spinner>
            </div>
        </div>
    );
};

export {PageSpinner};
